var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-loader",attrs:{"role":"status","aria-label":"Loading"}},[_c('app-spinner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }